import { CaptureObject, DocumentType } from './components/App/App';

interface Config {
	apiBaseUrl?: string;
	GOOGLE_MAPS_API_KEY?: string;
	SENTRY_API_URL?: string;
}

interface WebViewHandler {
	onVerificationSuccess: () => void;
	onVerificationFailure: (errorCode: string, errorMessage: string) => void;
	onImageUploadFailure: (errorCode: string, errorMessage: string) => void;
	onVideoUploadFailure: (errorCode: string, errorMessage: string) => void;
	onMediaUploadSuccess: () => void;
	isKYCApp: Promise<boolean>;
	isKYCAppAndroid: () => boolean;
	onNativeCameraRequested: (
		themeKey: string,
		documentType: DocumentType,
		currentProgress: number,
		totalSteps: number
	) => void;
}

interface ReactNativeWebView {
	postMessage: (message: string) => void;
}

declare global {
	interface Window {
		config: Config;
		ReactNativeWebView?: ReactNativeWebView;
		handler?: WebViewHandler;
		kicHandler: {
			cameraCompleted: (
				totalSteps: number,
				currentProgress: number,
				isKYCApp?: boolean
			) => void;
			onVideoCaptured: (base64Video: string, captureObject: CaptureObject) => void;
			onImageCaptured: (
				base64Image: string,
				captureObject: CaptureObject,
				deviceName?: string
			) => void;
		};
		isRedirecting: boolean;
		isAuthenticated: boolean;
		LC_API: any;
		__lc: any;
		initGoogleMaps: () => void;
	}
}

export default {
	apiBaseUrl: 'http://api-fe.pervesk-kyc.local:9999',
	GOOGLE_MAPS_API_KEY: 'AIzaSyAGjc0RmN5Bu8hZ2BCzlhV9ZEVvON8d-qg',
	SENTRY_API_URL: 'https://457665fa148f4551b7b7a7ffe77215f8@o1071378.ingest.sentry.io/6729201',
	...window.config
};

export const supportedLanguages = ['ar', 'de-DE', 'en', 'es-ES', 'fr', 'it', 'lt', 'ru'];
